import React from "react";
import {Grid, CircularProgress} from "@mui/material";

export default () => {
    return (
        <div style={{display: "flex", alignItems: "center", minHeight: "70vh"}}>
            <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justify="center"
            >

                <Grid item xs={3}>
                    <CircularProgress size={100} style={{color: "#ac0533"}}/>
                    <p>Loading ...</p>
                </Grid>
            </Grid>
        </div>
    );
}
